import React from 'react'
import { Card, Container, Subtitle, Title, Time } from './NoFees.style'
import { NoFeesIcon } from '@assets/index'
import FormPlateInput from 'parkdepot-shared/components/LPInput'
import { SpinnerContainer } from '../OrderInfo/OrderInfo.style'
import { Redirect, useLocation } from 'react-router-dom'
import Spinner from 'parkdepot-shared/components/Spinner'
import { DateTime } from 'luxon'
import useGetOpenOrders from '@hooks/useGetOpenOrders'
import Error from '@components/Error/Error.component'
import { useTranslation } from 'react-i18next'
import carpayHomeRoute from '../Home/route.const'

const CarpayNoFees = () => {
    const now = DateTime.now()
    const { search } = useLocation()
    const { t } = useTranslation()
    const searchParams = new URLSearchParams(search)
    const plate = searchParams.get('plate')
    const { data, loading, error } = useGetOpenOrders({
        variables: {
            plates: [plate!] // should exist because of skip
        },
        skip: !plate,
        fetchPolicy: 'cache-and-network'
    })

    if (loading && !data) {
        return (
            <SpinnerContainer>
                <Spinner theme="primary" size="xl" />
            </SpinnerContainer>
        )
    }

    if (error) {
        return <Error />
    }

    // @ts-ignore
    if (data?.b2c_get_open_orders.orders.length > 0 || !plate) {
        return <Redirect to={carpayHomeRoute} />
    }

    return (
        <Container>
            <Card>
                <img src={NoFeesIcon} alt="happy face" />
                <Title>{t('carpay.noFees.title')}</Title>

                <Subtitle>{t('carpay.noFees.subtitle')}</Subtitle>

                <div>
                    <FormPlateInput disabled readOnly value={plate} />
                    <Time>{now.toFormat('dd.MM.yyyy HH:mm')}</Time>
                </div>
            </Card>
        </Container>
    )
}

export default CarpayNoFees
